// for overcome floating point precision issue which is causing the issue in the validation (floating-point arithmetic)
export const roundingTheFloatNumber = (value: number, decimals: number): number => {
    return Number(Math.round(Number(`${value}e${decimals}`)) + `e-${decimals}`);
};